import { MegapushModel } from '../../../../components/dashboard/megapush/megapush.model';
import { UniverseEnum } from '../../../api/dashboard/universeEnum';
import { Customer } from '../../../api/dashboardV7/customer';
import { SharedService } from '../../../api/dashboardV7/sharedService';
import { KenobiTrackingCode } from '../../tracking/kenobiTrackingCode-model';
import { ForbiddenViewModel } from '../forbidden/forbidden.view-model';
import { RelationalV7ViewModel } from '../relationalV7.view-model';
import { SectionV7ViewModel } from '../sectionV7.view-model';
import { WhoUsesItViewModel } from '../whoUsesIt.view-model';
import { DashboardV7AlertsViewModel } from './dashboardV7-alerts.view-model';
import { DashboardV7HelpsViewModel } from './dashboardV7-helps.view-model';
import { DashboardV7WarnsViewModel } from './DashboardV7WarnsViewModel';

export class DashboardV7ViewModel {
    public universe: UniverseEnum;
    public customer?: Customer;
    public sharedServices?: SharedService[] = [];
    public forbidden?: ForbiddenViewModel;
    public kenobiCode: KenobiTrackingCode;
    public trackingLabel: string;
    public sections?: SectionV7ViewModel[] = [];
    public megapush?: MegapushModel;
    public relational?: RelationalV7ViewModel;
    public whoUsesIt?: WhoUsesItViewModel;
    public alerts?: DashboardV7AlertsViewModel[] = [];
    public infos?: DashboardV7HelpsViewModel[] = [];
    public warnings?: DashboardV7WarnsViewModel[] = [];
    public isSharedServicesNsru?: boolean;
    public isforbidden?: boolean;
    public contractId: string;
}
